import { LayoutOrientation } from '@ardoq/yfiles';
import type { BlocksLayoutOrientation } from 'tabview/visualizations/aq-blocks/types';

/** The orientation the diagram lays out for each stored one, total over the enum. */
export const ORIENTATION_TO_BLOCKS: Record<
  LayoutOrientation,
  BlocksLayoutOrientation
> = {
  [LayoutOrientation.TOP_TO_BOTTOM]: 'top-to-bottom',
  [LayoutOrientation.LEFT_TO_RIGHT]: 'left-to-right',
  [LayoutOrientation.RIGHT_TO_LEFT]: 'right-to-left',
  [LayoutOrientation.BOTTOM_TO_TOP]: 'bottom-to-top',
};
